import Vue from 'vue'
import request from '@/config/request.js'
// import tools from '@/util/tools'
import { Message } from 'element-ui'
import setting from '@/config/settings'
import RouteView from "@/components/routeView";
import Modules from "@/components/modules";
import moment from 'moment'

const ApiUser = request.UserLogin
const ApiLogin = request.UserLogin
const DoubleTeacher = request.DoubleTeacher
const ApiRenewal = request.Renewal
const BRAND_NAME_MAP = {
  'BRAND_AN': '贝尔安亲',
  'BRAND_YN': '贝尔优能',
  'BRAND_QN': '贝尔全能',
}
const HEADER_LOGO_MAP = {
  'BRAND_AN': require('../../../../static/images/header/logo.png'),
  'BRAND_YN': require('../../../../static/images/header/yn-logo.png'),
  'BRAND_QN': require('../../../../static/images/header/qn-logo.png'),
}

function parseStoreJson(text, fallback) {
  try {
    return text ? JSON.parse(text) : fallback
  } catch (e) {
    return fallback
  }
}

export default {
  name: 'header-nav',
  data () {
    const validatePass = (rule, value, callback) => {
      void rule
      const s = String(value == null ? '' : value)
      if (!s) return callback(new Error('请输入新密码'))
      if (s.length < 8) return callback(new Error('密码至少8位'))
      if (!/[A-Za-z]/.test(s)) return callback(new Error('密码需包含字母'))
      if (!/\d/.test(s)) return callback(new Error('密码需包含数字'))
      if (this.passInfo && this.passInfo.confirmPassword !== '') {
        const ref = this.$refs.headerPassForm
        if (ref && ref.validateField) ref.validateField('confirmPassword')
      }
      callback()
    }
    const validateNonNegativeInteger = (rule, value, callback) => {
      void rule
      const v = String(value == null ? '' : value).trim()
      if (v === '') { callback(new Error('请输入数值')); return }
      if (!/^(?:0|[1-9]\d*)$/.test(v)) { callback(new Error('只能输入0或正整数')); return }
      callback()
    }
    const validatePass2 = (rule, value, callback) => {
      void rule
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passInfo.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      language: 'zh',
      lang: [{
        // 模板语法的一种
        label: this.$t('message.zh'),
        value: 'zh'
      }, {
        label: this.$t('message.en'),
        value: 'en'
      }],
      qiniu: setting.gbs.qiniu,
      isCollapse: false,
      value: '',
      userInfo: JSON.parse(this.$store.state.login.userInfo),
      dropIcon: 'el-icon-arrow-down',
      userDialog: false,
      passWordDialog: false,
      formLabelWidth: '120px',
      passRules: {
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      passInfo: {
        mobile: JSON.parse(this.$store.state.login.userInfo).mobile,
        // password: '',
        newPassword: '',
        confirmPassword: ''
      },
      feedbackDialog: false,
      feedbackForm: {
        feedback: ''
      },
      feedbackRules: {
        feedback: [
          { required: true, message: '请输入您需要提的意见或者建议', trigger: 'blur' }
        ]
      },
      schoolsRules: {
        noonCareCapacity: [
          { required: true, message: '请输入午托最大可容纳学生人数', trigger: 'blur' },
          { validator: validateNonNegativeInteger, trigger: 'blur' },
          { validator: validateNonNegativeInteger, trigger: 'change' }
        ],
        eveningCareCapacity: [
          { required: true, message: '请输入晚托(含下午托和作业托)最大可容纳学生人数', trigger: 'blur' },
          { validator: validateNonNegativeInteger, trigger: 'blur' },
          { validator: validateNonNegativeInteger, trigger: 'change' }
        ],
        area: [
          { required: true, message: '请输入校区面积', trigger: 'blur' },
          { validator: validateNonNegativeInteger, trigger: 'blur' },
          { validator: validateNonNegativeInteger, trigger: 'change' }
        ]
      },
      changeTeacher: false,
      changeItem: '',
      changeTeacherList: JSON.parse(this.$store.state.login.schoolsTeacher),
      teacherID: undefined,
      apiCode: JSON.parse(this.$store.state.login.zoneTeacher)?.schoolZone?.apiCode || '',
      manager: JSON.parse(this.$store.state.login.zoneTeacher)?.manager || false,

      schoolsDialog: false,
      schoolsInfo: {
        brandName: '',
        zoneName: '',
        managerName: '',
        status: '',
        zoneAddress: '',
      } ,
      schoolsSettingInfo: {
        noonCareCapacity: '',
        eveningCareCapacity: '',
        area: ''
      },
      zoneId: '',
      campusInfo: {},
      stageOpttion: {
        supervision: 'S3督导',
        counselling: 'S1辅导',
        supervision_S2: 'S2督导',
        supervision_S3: 'S3督导',
      },
      timeTable: []
        // {
        //   supervision("S3督导"),
        // counselling("S1辅导"),
        // supervision_S2("S2督导"),
        // supervision_S3("S3督导");: 'S1辅导',
        //   supervision: 'S1辅导'
        // },
        // {
        //   label: 'S2督导',
        //   value: 'S2督导'
        // },
        // {
        //   label: 'S3督导',
        //   value: 'S3督导'
        // },
      

    }
  },
  computed: {
    route () {
      return this.$route
    },
    currentBrand () {
      const zoneTeacher = parseStoreJson(
        this.$store && this.$store.state && this.$store.state.login
          ? this.$store.state.login.zoneTeacher
          : null,
        null
      )
      const schoolsInfo = parseStoreJson(
        this.$store && this.$store.state && this.$store.state.login
          ? this.$store.state.login.schoolsInfo
          : null,
        null
      )
      const zoneTeacherBrand = zoneTeacher &&
        zoneTeacher.schoolZone &&
        (zoneTeacher.schoolZone.zoneBrand || zoneTeacher.schoolZone.brand)
        ? (zoneTeacher.schoolZone.zoneBrand || zoneTeacher.schoolZone.brand)
        : ''
      const schoolsBrand = schoolsInfo &&
        schoolsInfo.zoneTeacher &&
        schoolsInfo.zoneTeacher.schoolZone &&
        (schoolsInfo.zoneTeacher.schoolZone.zoneBrand ||
          schoolsInfo.zoneTeacher.schoolZone.brand)
        ? (schoolsInfo.zoneTeacher.schoolZone.zoneBrand ||
          schoolsInfo.zoneTeacher.schoolZone.brand)
        : ''
      return zoneTeacherBrand || schoolsBrand || 'BRAND_AN'
    },
    headerLogoSrc () {
      return HEADER_LOGO_MAP[this.currentBrand] || HEADER_LOGO_MAP.BRAND_AN
    },
    degree () {
      return this.schoolsSettingInfo.area ? (this.schoolsSettingInfo.area / 4).toFixed(0) : ''
    },
    pwdPolicyRuleList () {
      const pwd = this.passInfo && this.passInfo.newPassword
        ? String(this.passInfo.newPassword)
        : ''
      return [
        { key: 'len', text: '至少 8 位', ok: pwd.length >= 8 },
        { key: 'letter', text: '包含字母', ok: /[A-Za-z]/.test(pwd) },
        { key: 'digit', text: '包含数字', ok: /\d/.test(pwd) }
      ]
    }
  },
  watch: {
    // 侦听器
    language: function (val) {
      // 侦听单选按钮的变化，从而进行切换语言
      val === 'zh' ? this.$i18n.locale = 'zh' : this.$i18n.locale = 'en'
      Vue.set(this.lang, 'zh', { label: this.$t('message.zh'), value: 'zh' })
      Vue.set(this.lang, 'en', { label: this.$t('message.en'), value: 'en' })

      var Days = 30
      var exp = new Date()
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
      document.cookie = 'BELL_PLAY_LANG' + '=' + escape(val) + ';expires=' + exp.toGMTString()
    }
  },
  mounted () {
    this.zoneId = (this.$store && this.$store.state &&
    this.$store.state.login) ? this.$store.state.login.zoneId : ''

    this.$store.dispatch('setRouteList', this.$route)

    this.initCampusInfo()

    this.initListZoneSemester()
  },
  methods: {
    initListZoneSemester () {
      this.timeTable = []
      ApiUser.listZoneSemester.call(this, {}, (res) => {
        res.map((item) => {
        
        let data = {
          'id': item.id,
        "year": this.yearParse(item.year),
        "autumn": [
                item.autumnStartDate,
                item.autumnEndDate
              ],
          "winter": [
                  item.winterStartDate,
                  item.winterEndDate
                ],
          "spring": [
                  item.springStartDate,
                  item.springEndDate
                ],
          "summer": [
                  item.summerStartDate,
                  item.summerEndDate
                ],
          "isDefault": item.isDefault
          }
          this.timeTable.push(data)
        })
      })
    },
      yearOutput(param) {
        const v = Array.isArray(param)
          ? param
          : []
        const s = String(v[0] || '').trim()
        const e = String(v[1] || '').trim()
        if (!s || !e) return ''
        return s + '-' + e + '年'
      },
      yearParse(str) {
        const s = String(str == null ? '' : str).trim()
        const t = s.endsWith('年') ? s.slice(0, -1) : s
        const arr = t.split('-')
        const a = String(arr[0] || '').trim()
        const b = String(arr[1] || '').trim()
        return [a, b]
      },
      onSetDefault (data) {
        const paramData = {
          'id': data.id
        }
        let that = this
        ApiUser.setDefaultZoneSemester.call(that, paramData, (res) => {
          that.$message({
            message: '更新成功',
            type: 'success'
          })
          that.initListZoneSemester()
        })
      },
    addTimeTable () {
      let data = {
          "year": [
                  moment().format('YYYY'),
                  moment().add(1, 'year').format('YYYY'),
                ],
          "autumn": [
                  moment().month(8).date(1).format('YYYY-MM-DD'),
                  moment().add(1, 'year').month(0).date(30).format('YYYY-MM-DD')
                ],
          "winter": [
                  moment().month(1).date(1).format('YYYY-MM-DD'),
                  moment().month(1).date(28).format('YYYY-MM-DD'),
                ],
          "spring": [
                  moment().month(2).date(1).format('YYYY-MM-DD'),
                  moment().month(6).date(10).format('YYYY-MM-DD'),
                ],
          "summer": [
                  moment().month(6).date(11).format('YYYY-MM-DD'),
                  moment().month(7).date(31).format('YYYY-MM-DD'),
                ],
          "isDefault": true
          }
          
          const paramData = {
              "year": this.yearOutput(data.year),
              "autumnStartDate": data.autumn[0],
              "autumnEndDate": data.autumn[1],
              "winterStartDate": data.winter[0],
              "winterEndDate": data.winter[1],
              "springStartDate": data.spring[0],
              "springEndDate": data.spring[1],
              "summerStartDate": data.summer[0],
              "summerEndDate": data.summer[1],
              "isDefault": true
          }
          let that = this
          ApiUser.addZoneSemester.call(that, paramData, (res) => {
          //   console.log(res, '添加学期')
          //   that.timeTable.push({
          //     id: res.id,
          // "year": that.yearParse(res.year),
          // "autumn": [
          //         res.autumnStartDate,
          //         res.autumnEndDate
          //       ],
          // "winter": [
          //         res.winterStartDate,
          //         res.winterEndDate
          //       ],
          // "spring": [
          //         res.springStartDate,
          //         res.springEndDate
          //       ],
          // "summer": [
          //         res.summerStartDate,
          //         res.summerEndDate
          //       ],
          // "isDefault": res.isDefault
          // })
          this.initListZoneSemester()
          })
    },
    onEdit (data) {
          const paramData = {
              'id': data.id,
              "year": this.yearOutput(data.year),
              "autumnStartDate": data.autumn[0],
              "autumnEndDate": data.autumn[1],
              "winterStartDate": data.winter[0],
              "winterEndDate": data.winter[1],
              "springStartDate": data.spring[0],
              "springEndDate": data.spring[1],
              "summerStartDate": data.summer[0],
              "summerEndDate": data.summer[1],
              "isDefault": data.isDefault
          }
          ApiUser.updateZoneSemester.call(this, paramData, (res) => {
           this.$message({
                message: '更新成功',
                type: 'success'
              })
              this.initListZoneSemester()
          })
    },
    onDelete (data) {
          const paramData = {
              'id': data.id
          }
          ApiUser.deleteZoneSemester.call(this, paramData, (res) => {
            this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.initListZoneSemester()
          })
    },
     initCampusInfo () {
      let param = {
        "zoneId": this.zoneId
       }
      ApiRenewal.getCampusInfo.call(this, param,(res) => {
        this.campusInfo = res?.data || {}
      })
    },
    getSrtSubstring (path) {
      if (path.indexOf('/') > -1) {
        return path.substr(1)
      } else {
        return path
      }
    },
    routeMatch (array) {
      return new Promise((resolve) => {
        let arr = []
        arr = array.map(item => {
          const listSplit = item.component.split('.')
          let module = ''
          if (item.component.indexOf('RouteView') > -1) {
            for (let i = 1; i < listSplit.length; i++) {
              module = module ? module[listSplit[i]] : RouteView[listSplit[i]]
            }
          } else if (item.component.indexOf('Modules') > -1) {
            for (let i = 1; i < listSplit.length; i++) {
              module = module ? module[listSplit[i]] : Modules[listSplit[i]]
            }
          }
          let listArr = []
          listArr = item.children.map(list => {
            let module = ''
            const splita = list.component.split('.')
            if (list.component.indexOf('RouteView') > -1) {
              for (let i = 1; i < splita.length; i++) {
                module = module ? module[splita[i]] : RouteView[splita[i]]
              }
            } else if (list.component.indexOf('Modules') > -1) {
              for (let i = 1; i < splita.length; i++) {
                module = module ? module[splita[i]] : Modules[splita[i]]
              }
            }
            return {
              path: this.getSrtSubstring(list.path),
              name: this.getSrtSubstring(list.path),
              meta: {
                name: list.name
              },
              component: module
            }
          })
          if (listArr.length > 0) {
            listArr = [{
              path: '/',
              redirect: to => {
                const str = listArr[0].path
                if (str.indexOf('/') > -1) {
                  return str.substr(1)
                } else {
                  return str
                }
              },
              hidden: true
            }, ...listArr]
          }
          return {
            path: item.path,
            meta: {
              name: item.name,
              keepAlive: true
            },
            component: module,
            children: listArr,
            name: item.path
          }
        })
        resolve(arr)
      })
    },
    setMenu (menu) {
      return new Promise((resolve) => {
        this.$store.dispatch('setRootMenu', JSON.stringify(menu))
        resolve()
      })
    },
    getTeacher () {
      if (!this.teacherID) {
        Message({
          message: '请选择切换的校区！',
          type: 'error'
        })
        return
      }
      ApiLogin.changeLoginZoneTeacher2.call(this, { zoneTeacherId: this.teacherID }, (res) => {
        this.$store.dispatch('loginIn', 'Bearer ' + res.token)
        this.$store.dispatch('setSchoolsInfo', JSON.stringify(res))
        this.$store.dispatch('setZoneId', res.zoneTeacher.schoolZone.zoneId)
        this.$store.dispatch('setZoneTeacher', JSON.stringify(res.zoneTeacher))
        this.$nextTick(() => {
          ApiLogin.zoneFeatureIsBroadcast.call(this, {}, item => {
            this.$store.dispatch('setOtoStatus', item)
          })
          ApiLogin.getTeacherAccountInfoByTeacherId.call(this, { teacherId: this.teacherID }, item => {
            this.$store.dispatch('setUserInfo', JSON.stringify(item))
            this.userInfo = item
            ApiLogin.getMenus.call(this, {}, dataMenu => {
              if (dataMenu.length === 0) {
                Message({
                  message: '未分配任何菜单权限，请联系管理员！',
                  type: 'error'
                })
              }
              this.changeTeacher = false
              this.setMenu(dataMenu).then(() => {
                this.routeMatch(JSON.parse(this.$store.state.login.rootMenu)).then(rt => {
                  this.$router.options.routes = this.$router.options.routes.concat(rt)
                  this.$router.addRoutes(rt)
                  for (const router in dataMenu) {
                    if (dataMenu[router].children.length > 0) {
                      this.$nextTick(() => {
                        window.location.reload()
                        
                      })
                      break
                    } else {
                      this.$nextTick(() => {
                        window.location.reload()
                        
                      })
                    }
                  }
                })
              })
            })
          })
        })
      })
    },
    changeRadio (e) {
      this.teacherID = e
    },
    feedbackSave (formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ApiUser.feedbackSave.call(this, { content: that.feedbackForm.feedback }, data => {
            that.$message({
              message: data.result,
              type: 'success'
            })
            this.feedbackDialog = false
          })
        }
      })
    },
    onDropDown (e) {
      if (e) {
        this.$data.dropIcon = 'el-icon-arrow-up'
      } else {
        this.$data.dropIcon = 'el-icon-arrow-down'
      }
    },
    changeMenu (e) {
      this.isCollapse = e
      this.$store.dispatch('changeIsCollapse', e)
    },
    onUpdatePassWord (formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ApiUser.changPassword.call(this, that.passInfo, data => {
            that.$message({
              message: '修改成功',
              type: 'success'
            })
            this.$store.dispatch('setUserLogin', {
              loginName: that.passInfo.mobile,
              loginPwd: that.passInfo.newPassword
            })
            localStorage.removeItem('bell_admin_pwd_force_change')
            that.passInfo.newPassword = ''
            that.passInfo.confirmPassword = ''
            this.passWordDialog = false
            this.$nextTick(() => {
              const ref = this.$refs.headerPassForm
              if (ref && ref.clearValidate) ref.clearValidate()
            })
          })
        }
      })
    },
    onSave (formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ApiUser.updateSelfInfo.call(this, that.info, data => {
            ApiUser.getUserInfo.call(this, {}, userinfo => {
              that.$store.dispatch('setUserInfo', JSON.stringify(userinfo.data))
              that.$message({
                message: '保存成功',
                type: 'success'
              })
              this.userDialog = false
            })
          })
        }
      })
    },
    getHelpback () {
      this.$router.push(
        {
          path: '/help'
        }
      )
    },
    getFeedback () {
      this.feedbackDialog = true
    },
    selectCommand (val) {
      if (val === 'help') {
        this.$router.push(
          {
            path: '/help'
          }
        )
      }
      if (val === 'info') {
        this.info = {
          trueName: this.userInfo.trueName,
          phone: this.userInfo.phone
        }
        this.userDialog = true
      }
      if (val === 'password') {
        this.passWordDialog = true
      }
      if (val === 'loginout') {
        this.$confirm('确定退出系统吗？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('delUserLogin')
          this.$store.dispatch('clearRoute', [])
          this.$router.push(
            {
              path: '/login'
            }
          )
          DoubleTeacher.logout.call(this, {}, res => {});
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          })
        })
      }
      if (val === 'details') {
        this.$router.push(
          {
            path: '/campus/details'
          }
        )
      }
      if (val === 'feedback') {
        this.feedbackDialog = true
      }
      if (val === 'changeTeacher') {
        this.changeTeacher = true
      }
      if (val === 'schoolsSetting') {
        let serviceState = {
          'normal': '正常',
          'preparation': '筹备',
          'suspended': '暂停', //暂停 
          'expires': '待续费', //待续费
          'close': '闭校', //闭校
          'invalid': '作废', //作废
        }


        
        ApiRenewal.getCurrentSchoolZone.call(this, {},(res) => {
           this.schoolsInfo = {
              brandName: BRAND_NAME_MAP[res.brand  || ''] || '',
              zoneName: res.zoneName || '',
              managerName: res.managerName || '',
              status: serviceState[res.serviceState || ''] || '',
              zoneAddress: res.address || '',
              stage: this.stageOpttion[res.stage || ''] || '',
            } 
            this.schoolsSettingInfo = {
              noonCareCapacity: res.noonCareCapacity || 0,
              eveningCareCapacity: res.eveningCareCapacity || 0,
              area: res.area || 0
            }
        })
        this.schoolsDialog = true
        this.$nextTick(() => {
          if (this.$refs['schoolsForm']) this.$refs['schoolsForm'].clearValidate()
        })
        
      }
    },
    // 更新学校容量
    updateCareCapacity () {
      
      this.$refs['schoolsForm'].validate(valid => {
        if (valid) {
            this.$confirm('确认更新校区设置？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            ApiUser.updateCareCapacity.call(this, this.schoolsSettingInfo, data => {
                this.$message({
                  message: '更新成功',
                  type: 'success'
                })

                let zoneTeacher = JSON.parse(this.$store.state.login.zoneTeacher)
                zoneTeacher.schoolZone.noonCareCapacity = this.schoolsSettingInfo.noonCareCapacity
                zoneTeacher.schoolZone.eveningCareCapacity = this.schoolsSettingInfo.eveningCareCapacity
                zoneTeacher.schoolZone.area = this.schoolsSettingInfo.area
                this.$store.dispatch('setZoneTeacher', JSON.stringify(zoneTeacher))
                 
                this.schoolsDialog = false
              })
            })
        }
      })
      
      
      
    },
  }
}
